module.exports = __webpack_public_path__ + "img/HotspotChoice.2e3c30db.png";